(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  let openAfter = document.querySelector('.after_open');
  let popupAfter = document.querySelector('.popup_after');
  let closeAfter = document.querySelector('.popup_after .button-close');
  let backAfter = document.querySelector('.afterpay-modal-back');
  let bodyMain = document.querySelector('body');

  openAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    popupAfter.classList.add('popup_after-open');
    
    bodyMain.classList.remove('body_hidden');
    bodyMain.classList.add('body_hidden');
  };
  closeAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    bodyMain.classList.remove('body_hidden');
    
  };
  backAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    bodyMain.classList.remove('body_hidden');
  };
 
 
  
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  var linkList = document.querySelectorAll('.site-navigation .site-nav__item:last-child a');

  if (linkList) {
    for (var i in linkList) {
      linkList[0].setAttribute("target", '_blank');
    }
  }

// Swiper announcement

  if(document.querySelector('.announcement-swiper') && window.Swiper) {
    const swiper = new Swiper(".announcement-swiper", {
      spaceBetween: 50,
      loop: true,
      lazy: true,
      simulateTouch: false,
      allowTouchMove: false,
      initialSlide: 0,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      }
    });
  }
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-liquid-test"]) return;
  try {
    
  let openAfter = document.querySelector('.after_open');
  let popupAfter = document.querySelector('.popup_after');
  let closeAfter = document.querySelector('.popup_after .button-close');
  let backAfter = document.querySelector('.afterpay-modal-back');
  let bodyMain = document.querySelector('body');

  let openNeed = document.querySelector('#need_open');
  let popupNeed = document.querySelector('.popup_need');
  let closeNeed = document.querySelector('.popup_need .button-close');
  let backNeed = document.querySelector('.need-modal-back');
  let bodyNeed = document.querySelector('body');

  openAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    popupAfter.classList.add('popup_after-open');
    
    bodyMain.classList.remove('body_hidden');
    bodyMain.classList.add('body_hidden');
  };
  closeAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    bodyMain.classList.remove('body_hidden');
    
  };
  backAfter.onclick = function() {
    popupAfter.classList.remove('popup_after-open');
    bodyMain.classList.remove('body_hidden');
  };

  openNeed.onclick = function() {
    popupNeed.classList.remove('popup_need-open');
    popupNeed.classList.add('popup_need-open');
    
    bodyMain.classList.remove('body_hidden');
    bodyMain.classList.add('body_hidden');

    return false;
  };
  closeNeed.onclick = function() {
    popupNeed.classList.remove('popup_need-open');
    bodyMain.classList.remove('body_hidden');
    
  };
  backNeed.onclick = function() {
    popupNeed.classList.remove('popup_need-open');
    bodyMain.classList.remove('body_hidden');
  };

  
   document.addEventListener("DOMContentLoaded", () => {
      let opel = document.getElementsByClassName('not-color-swatch');
      let coel = document.getElementsByClassName('color-swatch');
      let cartBtnenable = document.querySelectorAll(".add-to-cart");
      let opeldata;
      let checksize;
      let checksizeval;
      for(var i =0; i< opel.length; i++){
        opel[i].onclick = function(){ 
          opeldata = this.closest(".variant-input").getAttribute("data-value");
          this.closest(".variant-wrapper").querySelector('.variant__label-info_name').innerHTML = opeldata;
          // setTimeout(disBtn, 50);
        }
      }
      // function disBtn() {
      //   for(let item of cartBtnenable) {
      //     item.disabled = true;
      //   }
      // }
      function findchecksize() {
        checksize = document.querySelector('input[name="Size"]:checked');
        checksizeval = checksize.closest(".variant-input").getAttribute("data-value");
        checksize.closest(".variant-wrapper").querySelector('.variant__label-info_name').innerHTML = checksizeval;
        // for(let item of cartBtnenable) {
        //   item.disabled = true;
        // }
      }
      for(var i =0; i< coel.length; i++){
        coel[i].onclick = function(){ 
          setTimeout(findchecksize, 50);
          
        }
      }
       
  });
 
  
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
      let openAfter = document.querySelector('.after_open');
      let popupAfter = document.querySelector('.popup_after');
      let closeAfter = document.querySelector('.popup_after .button-close');
      let backAfter = document.querySelector('.afterpay-modal-back');
      let bodyMain = document.querySelector('body');

      let openNeed = document.querySelector('#need_open');
      let popupNeed = document.querySelector('.popup_need');
      let closeNeed = document.querySelector('.popup_need .button-close');
      let backNeed = document.querySelector('.need-modal-back');
      let bodyNeed = document.querySelector('body');

      // console.log(openNeed);

      // document.querySelector('#need_open').addEventListener('click', function (){
      // document.querySelector('.popup_need').classList.add('popup_need-open');
      // });

      if(openNeed) {
        openNeed.onclick = function() {
          popupNeed.classList.remove('popup_need-open');
          popupNeed.classList.add('popup_need-open');

          bodyMain.classList.remove('body_hidden');
          bodyMain.classList.add('body_hidden');

          return false;
        };
        closeNeed.onclick = function() {
        popupNeed.classList.remove('popup_need-open');
        bodyMain.classList.remove('body_hidden');

        };
        backNeed.onclick = function() {
        popupNeed.classList.remove('popup_need-open');
        bodyMain.classList.remove('body_hidden');
        };
      }

      if(openAfter) {
        openAfter.onclick = function() {
        popupAfter.classList.remove('popup_after-open');
        popupAfter.classList.add('popup_after-open');

        bodyMain.classList.remove('body_hidden');
        bodyMain.classList.add('body_hidden');
        };
        closeAfter.onclick = function() {
        popupAfter.classList.remove('popup_after-open');
        bodyMain.classList.remove('body_hidden');

        };
        backAfter.onclick = function() {
        popupAfter.classList.remove('popup_after-open');
        bodyMain.classList.remove('body_hidden');
        };
      }

    });

      document.addEventListener("DOMContentLoaded", () => {
        let opel = document.getElementsByClassName('not-color-swatch');
        let coel = document.getElementsByClassName('color-swatch');
        let cartBtnenable = document.querySelectorAll(".add-to-cart");
        let opeldata;
        let checksize;
        let checksizeval;
        for(var i =0; i< opel.length; i++){
          opel[i].onclick = function(){
            opeldata = this.closest(".variant-input").getAttribute("data-value");
            this.closest(".variant-wrapper").querySelector('.variant__label-info_name').innerHTML = opeldata;
            // setTimeout(disBtn, 50);
          }
        }
        // function disBtn() {
        //   for(let item of cartBtnenable) {
        //     item.disabled = true;
        //   }
        // }
        function findchecksize() {
          checksize = document.querySelector('input[name="Size"]:checked');
          checksizeval = checksize.closest(".variant-input").getAttribute("data-value");
          checksize.closest(".variant-wrapper").querySelector('.variant__label-info_name').innerHTML = checksizeval;
          // for(let item of cartBtnenable) {
          //   item.disabled = true;
          // }
        }
        for(var i =0; i< coel.length; i++){
          coel[i].onclick = function(){
            setTimeout(findchecksize, 50);

          }
        }

      });
      
  
  } catch(e) { console.error(e); }
})();
})();
